import { render, staticRenderFns } from "./shippedList.vue?vue&type=template&id=1a7e1a10"
import script from "./shippedList.vue?vue&type=script&lang=js"
export * from "./shippedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports